module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/新技术发展-text.86626c55.png";